export const templateFileDownloader = {
  methods: {
    downloadDocx() {
      this.$cmsService.letterTemplate().then(response => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })

        const url = window.URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = url
        a.download = 'TAM_Briefvorlage.docx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        window.URL.revokeObjectURL(url)

        this.docxDownloaded = true
      }).catch(error => {
        console.error('Download fehlgeschlagen:', error)
        this.docxDownloaded = false
      })
    }
  }
}
